import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseApiService } from '../../../core/base-api.service';
import { ApiResponse, PageableApiResponse } from '../../api-response';
import { FleetTile, FleetTileDetail } from '../models/monitoring.model';

/**
 * The two calls that render the Monitor page's Fleet tab end to end:
 *
 * - `GET /monitoring/fleet` — paginated grid data (Compact and Detailed
 *   density both use this; no per-tile follow-up calls for battery/signal/
 *   snapshot). See `FleetTile`'s doc comment for field-level caveats
 *   (label/model are stopgaps, signal is an unbucketed raw number).
 * - `GET /monitoring/{clientId}/detail` — rail data, fetched once per
 *   selection. Self-contained: works for a clientId that isn't on the
 *   currently-loaded grid page (e.g. a Map-tab pin selection).
 */
@Injectable({ providedIn: 'root' })
export class FleetService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${this.coreApiUrl}/api/v1/device/monitoring`;

  getFleetTiles(page: number, size: number, sort: string): Observable<PageableApiResponse<FleetTile>> {
    return this.http.get<PageableApiResponse<FleetTile>>(
      `${this.baseUrl}/fleet?page=${page}&size=${size}&sort=${sort}`,
    );
  }

  getDeviceDetail(clientId: string): Observable<ApiResponse<FleetTileDetail>> {
    return this.http.get<ApiResponse<FleetTileDetail>>(`${this.baseUrl}/${encodeURIComponent(clientId)}/detail`);
  }
}
